/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToRem, pxToEm, mediaQuery, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION: AVATAR PACK SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  useravatarsection: {
    '& > .collapsable': {
      '& .innerWrap': {
        display: 'flex',
        [mediaQuery.customizeThinnest]: {
          display: 'block'
        }
      }
    },
    '& .sectiondescription': {
      '& .avatarpreview': {
        marginTop: pxToEm(2),
        '& img': {
          height: pxToEm(32)
        }
      }
    },
    '& .collapsable.opened': {
      maxHeight: pxToRem(3000),
      '& .innerWrap': {
        display: 'flex',
        [mediaQuery.customizeThinnest]: {
          display: 'block'
        }
      }
    },
    '& .avatarconfig': {
      marginRight: pxToEm(8),
      [mediaQuery.customizeThinnest]: {
        marginRight: 0,
        marginBottom: pxToEm(8)
      },
      '& .sectioncard': {
        padding: replacePXinStringWithEM('32px 24px 36px 24px'),
        [mediaQuery.customizeThinnest]: {
          textAlign: 'center',
          padding: replacePXinStringWithEM('32px 24px 32px 24px')
        }
      },
      '& .content': {
        '& .controls': {
          marginTop: pxToEm(16),
          display: 'flex',
          [mediaQuery.customizeThinnest]: {
            display: 'block'
          },
          '& .selectablelist': {
            width: '100%',
            '& div': {
              width: '100%',
              '& label': {
                maxWidth: '100%',
                marginBottom: pxToEm(16),
              }
            }
          },
          '& .control': {
            maxWidth: pxToEm(180),
            [mediaQuery.customizeThinnest]: {
              margin: 'auto',
              '&:last-child': {
                marginTop: pxToEm(8)
              }
            }
          }
        }
      }
    },
    '& .avatarpreview': {
      marginTop: 0,
      '& .sectioncard': {
        padding: 0
      },
      '& .avatarcontainer': {
        display: 'block',
        padding: replacePXinStringWithEM('50px 32px 50px 32px'),
        '& .avatarset': {
          display: 'flex',
          marginBottom: pxToEm(16),
          marginTop: 0,
          [mediaQuery.customizeThinnest]: {
            placeContent: 'center'
          },
          '&:last-child': {
            marginBottom: '0px'
          },
          '& img': {
            [mediaQuery.customizeThinnest]: {
              width: pxToEm(32),
              height: pxToEm(32),
              marginRight: pxToEm(4)
            },
            width: pxToEm(52),
            height: pxToEm(52),
            marginRight: pxToEm(32),
            border: 'none',
            '&:last-child': {
              marginRight: 0
            }
          }
        }
      },
      '& .preview': {
        cursor: 'pointer',
        marginTop: pxToEm(32),
        paddingTop: pxToEm(12),
        height: pxToEm(48),
        textAlign: 'center',
        borderTop: `1px solid #ecf0f7`,
        '& span': {
          color: theme.color.primary.medium.swatch,
          fontSize: pxToEm(14),
          fontWeight: '500'
        }
      }
    },
    '& .avatarpreviewwrapper': {
      '& img': {
        marginRight: -4,
        borderRadius: '50%',
        border: '2px solid #f4f4f2'
      }
    }
  }
});
